import { createContext, useContext, useState } from 'react';

const TicketContext = createContext();

export const TicketProvider = ({children}) => {
    const [totalTickets, setTotalTickets] = useState(0);

    return (
        <TicketContext.Provider value={{ totalTickets, setTotalTickets }}>
            {children}
        </TicketContext.Provider>
    )
}

export const useTicket = () => {
    return useContext(TicketContext);
}